// extracted by mini-css-extract-plugin
module.exports = {"icon":"lbNczdj1RJlgGup9IHpnkg=="};